var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrust2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_15229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.896 48.0156L23.188 47.7016C22.4 47.3556 4 39.0456 4 23.9976V10.9496C4.0007 9.69397 4.39757 8.47054 5.13408 7.45357C5.87059 6.4366 6.9092 5.67794 8.102 5.28562L24 0.015625L39.898 5.28562C41.0908 5.67794 42.1294 6.4366 42.8659 7.45357C43.6024 8.47054 43.9993 9.69397 44 10.9496V23.9976C44 41.1516 25.424 47.5076 24.632 47.7716L23.896 48.0156ZM24 4.20962L9.368 9.06163C8.96989 9.19166 8.62314 9.44434 8.37741 9.78348C8.13168 10.1226 7.99957 10.5308 8 10.9496V23.9976C8 34.9856 20.88 42.1136 24.094 43.7196C27.302 42.4296 40 36.5236 40 23.9976V10.9496C40.0004 10.5308 39.8683 10.1226 39.6226 9.78348C39.3769 9.44434 39.0301 9.19166 38.632 9.06163L24 4.20962Z",
    fill: "#843ECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2235 29.0788H22.1575C21.6512 29.0711 21.1519 28.9607 20.6895 28.7545C20.2271 28.5482 19.8114 28.2503 19.4675 27.8788L14.8555 23.0788L17.7375 20.3148L22.2255 24.9948L32.5875 14.6328L35.4155 17.4608L24.8935 27.9828C24.543 28.333 24.1266 28.6102 23.6683 28.7983C23.21 28.9864 22.7189 29.0818 22.2235 29.0788Z",
    fill: "#843ECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_15229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust2);
export default __webpack_public_path__ + "static/media/trust2.28eb57747ccbbb5224807f67feabd91a.svg";
export { ForwardRef as ReactComponent };